import React, { memo } from "react";
import { FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";

type AddressInputFieldProps = {
  register: any;
  errors: any;
}
export const RestaurantAddressInputField: React.FC<AddressInputFieldProps> = memo(({register, errors}) => {
  const addressError = errors.restaurant?.address?.message;
  return (
    <FormControl isRequired isInvalid={errors.restaurant?.address} w='100%'>
      <FormLabel>住所</FormLabel>
      <Input type="text" {...register('restaurant.address')} />
      <FormErrorMessage>{addressError}</FormErrorMessage>
    </FormControl>
  );
});
